$ = jQuery;

$(function(){
  if (typeof(mapLat) === 'undefined' || typeof(mapLong) === 'undefined') {
    return;
  }

  google.maps.Map.prototype.panToWithOffset = function(latlng, offsetX, offsetY) {
    var map = this;
    var ov = new google.maps.OverlayView();
    ov.onAdd = function() {
      var proj = this.getProjection();
      var aPoint = proj.fromLatLngToContainerPixel(latlng);
      aPoint.x = aPoint.x+offsetX;
      aPoint.y = aPoint.y+offsetY;
      map.panTo(proj.fromContainerPixelToLatLng(aPoint));
    }; 
    ov.draw = function() {}; 
    ov.setMap(this); 
  };

  google.maps.Map.prototype.markerOffset = function(latlng, offsetX, offsetY) {
    var map = this;
    var ov = new google.maps.OverlayView();
    var newPos = 0;
    ov.onAdd = function() {
      var proj = this.getProjection();
      var aPoint = proj.fromLatLngToContainerPixel(latlng);
      aPoint.x = aPoint.x+offsetX;
      aPoint.y = aPoint.y+offsetY;
      newPos = proj.fromContainerPixelToLatLng(aPoint);
    }; 
    
    return newPos;
  }

  if ( $(window).width() < 1024) {
       mapOptions = {
          zoom: 14,
          streetViewControl: false,
              disableDefaultUI:true,
              draggable: false, 
                zoomControl: false, 
                scrollwheel: false, 
                disableDoubleClickZoom: true,
          center: new google.maps.LatLng(mapLat,mapLong),
          mapTypeId: google.maps.MapTypeId.ROADMAP
        };
  }
  else {
        mapOptions = {
          scrollwheel: false,
        streetViewControl: false,
            disableDefaultUI:true,
        zoom: 14,
        zoomControl: true,
        center: new google.maps.LatLng(mapLat,mapLong),
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
  }

  initialize(); 
  
  //Set Tabclicks
  $('.mapTabs li a').each(function(){
    $(this).click(function(){
      beachMarker.setPosition(new google.maps.LatLng( $(this).attr('data-lat'), $(this).attr('data-long')));
      responsiveMap.panTo(new google.maps.LatLng( $(this).attr('data-lat'), $(this).attr('data-long')));
    });
  });

  $('#phone-select').on('change', function (e) {
    beachMarker.setPosition(new google.maps.LatLng( $('.mapTabs li a').eq($(this).val()).attr('data-lat'), $('.mapTabs li a').eq($(this).val()).attr('data-long')));
    responsiveMap.panTo(new google.maps.LatLng( $('.mapTabs li a').eq($(this).val()).attr('data-lat'), $('.mapTabs li a').eq($(this).val()).attr('data-long')));
  });
  
});



function initialize() {

  var styles = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#cae7f0"
            },
            {
                "visibility": "on"
            }
        ]
    }
];

  var styledMap = new google.maps.StyledMapType(styles,{name: "Styled Map"});

  $mapCanvas = $('<div />', { 'id':'map-canvas', 'style':'height:310px;' });
  $mapCanvas.prependTo('.mainText .tab-content .map-canvas');

  //responsiveMap = new google.maps.Map($mapCanvas, mapOptions);


  responsiveMap = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

  responsiveMap.mapTypes.set('map_style', styledMap);
  responsiveMap.setMapTypeId('map_style');

  var image = {
    url: baseUrl + '/assets/images/map-marker.png',
    scaledSize: new google.maps.Size(104, 75),
    anchor: new google.maps.Point(52, 63)
  };

  var myLatLng = new google.maps.LatLng(mapLat,mapLong);
  beachMarker = new google.maps.Marker({
    position: myLatLng,
    map: responsiveMap,
    icon: image
  });
  responsiveMap.panToWithOffset(beachMarker.getPosition(), 0, -12);
  
  
  //Start centercheck
  setMapcenter();
   
}

var mapTimer;
function setMapcenter(){
  $(window).resize(function() {
    window.clearTimeout(mapTimer);
    mapTimer = window.setTimeout(function(){
      responsiveMap.panToWithOffset(beachMarker.getPosition(), 0, -12);
    },200); 
  });
}




